/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'app.bsky.authManageFeedDeclarations'

type $nsid = typeof $nsid

export { $nsid }

const main = /*#__PURE__*/ l.permissionSet(
  $nsid,
  [
    /*#__PURE__*/ l.permission('repo', {
      action: ['create', 'update', 'delete'],
      collection: ['app.bsky.feed.generator'],
    }),
  ],
  {
    title: 'Manage Hosted Feeds',
    'title:lang': {},
    detail: 'Configure feed generator declaration records.',
    'detail:lang': {},
  },
)

export { main }
